import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
@Component({
  selector: 'app-reception-repairman-sms',
  templateUrl: './reception-repairman-sms.component.html',
  styleUrls: ['./reception-repairman-sms.component.scss']
})
export class ReceptionRepairmanSmsComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public loading2: boolean = false;
  public subscription: Subscription | any;
  public server_main!: any;
  public server!: any;
  public user_id!: number;
  public reception_id!: number;
  public creator!: number;
  public user_title!: string;
  public device_title!: string;
  public cost_sms!: number;
  public list_cellphone: any = [];

  constructor(
    public serverService: ServerService,
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public _dialogRef: MatDialogRef<ReceptionRepairmanSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server();
    if (dialog_data) {
      this.reception_id = dialog_data.reception_id;
      this.creator = dialog_data.creator;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id
    }
    this.get_data();
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7241,
      'reception_id': this.reception_id,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.user_title = res['result'][0].user_title;
            this.device_title = res['result'][0].wharehouse_device_title;
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  check_cellphone_sms2(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var x = window.confirm(this.messageService.message_sms_accept());
    if (x == false) {
      this.message(false, "", 1, this.messageService.close());
      return false;
    }
    this.loading = true;
    var count = 0;
    var obj = {
      'address': 6818,
      'id': this.reception_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_cellphone = [];
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].user_cellphone.length == 11 && res['result'][i].user_cellphone.match(/^\d{11}$/g)) {
              count++;
              this.list_cellphone.push(res['result'][i].user_cellphone);
            }
          }
          if (this.list_cellphone.length > 0) this.check_charge_sms2(count);
          else {
            var pe_message = "برای ارسال پیامک ، بایستی حداقل یک تعمیرکار با شماره موبایل درست مشخص می باشد";
            this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  check_charge_sms2(count: number): any {
    var obj = {
      'address': 6312,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['result'][0].amount >= count * 1000) {
              for (var i = 0; i < this.list_cellphone.length; i++) {
                this.send_sms2(this.list_cellphone[i], count, i + 1);
              }
            }
            else {
              var pe_message = "قادر به ارسال پیامک نمی باشید لطفا شارژ نمائید";
              this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
            }
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  send_sms2(cellphone: number, count1: number, count2: number): any {
    var obj = {
      'address': 6819,
      'cellphone': cellphone,
      'device_title': this.device_title
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (count1 == count2) {
          var pe_message = "پیام با موفقیت ارسال شد";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
        this.log_sms(res['response'].body.entries[0].cost);
      })
  }
  log_sms(cost: number) {
    var obj = {
      'address': 6308,
      'user_id': this.user_id,
      'creator': this.creator,
      'cost': cost
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.serverService.send_sms_charge();
        }//end if
        else {
          var pe_message = "خطا در ثبت لاگ پیامک ارسالی";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  close() {
    this._dialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
